import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
    initMasterProductInfo,
    requestMasterProductStart,
    requestMasterProductSuccess,
    requestAllMasterProductSuccess,
    requestMasterProductFail,

    postMasterProductStart,
    postMasterProductSuccess,
    postMasterProductFail,

    patchMasterProductStart,
    patchMasterProductSuccess,

    deleteMasterProductStart,
    deleteMasterProductSuccess,
    deleteMasterProductFail,

    requestDetailMasterProductStart,
    requestDetailMasterProductSuccess,
    requestDetailMasterProductFail,

    putMasterProductStart,
    putMasterProductSuccess,
    putMasterProductFail,

    deleteMultipleMasterProductStart,
    deleteMultipleMasterProductSuccess,
    deleteMultipleMasterProductFail,

    patchMultipleMasterProductStart,
    patchMultipleMasterProductSuccess,
    patchMultipleMasterProductFail,

    putMultipleMasterProductStart,
    putMultipleMasterProductSuccess,
    putMultipleMasterProductFail,

    checkBarcodeFail,
    checkBarcodeStart,
    checkBarcodeSuccess,

    importMasterProductStart,
    importMasterProductSuccess,
    importMasterProductFail,

    requestImportMasterProductStart,
    requestImportMasterProductSuccess,
    requestImportMasterProductFail,

    searchProductFail,
    searchProductStart,
    searchProductSuccess,

} from '../actions/master-product';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_PUT, method_PATCH, method_DELETE, method_MULTIPLE_DELETE, method_MULTIPLE_PATCH, method_MULTIPLE_PUT, method_IMPORT } = requestManagement;

import CONFIG from '@root/config/config.next';

const url = CONFIG.backendEndpoint;

export function* requestMasterProduct({ payload }) {

    /*console.log('[sages] requestMasterProduct : ', payload);*/

    const apiURL = `${url}/backend/v1/product`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
            params: {
                "pagination[page]": payload.page === 0 ? 1 : payload.page,
                "pagination[limit]": payload.limit,
                "sort[field]": payload.field,
                "sort[order]": payload.order,
                "filter[status]": payload.status,
                "filter[q]": payload.q,
                "filter[parent]": payload.parent,
                "filter[category_display]": payload.category_display,
                "filter[brand]": payload.brand,
                "filter[branch]": payload.branch,
            }
        });

        /*console.log("[API] GET : ", data);*/
        if (payload.limit === 'all') {
            yield put(requestAllMasterProductSuccess(data));
        } else {
            yield put(requestMasterProductSuccess(data));
        }

    } catch (error) {
        yield put(requestMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* postMasterProduct({ payload }) {
    /*console.log('[sages] postMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/product`;

    //====================================================================================================================

    try {
        const data = yield method_POST(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(postMasterProductSuccess(data));

    } catch (error) {
        yield put(postMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* patchMasterProduct({ payload }) {
    /*console.log('[sages] patchMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/product/${payload?.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_PATCH(
            {
                url: apiURL,
                data: payload?.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(patchMasterProductSuccess(data));

    } catch (error) {
        // yield put(patchMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* deleteMasterProduct({ payload }) {
    /*console.log('[sages] deleteMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/product/${payload?.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_DELETE(
            {
                url: apiURL,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(deleteMasterProductSuccess(data));

    } catch (error) {
        yield put(deleteMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* requestDetailMasterProduct({ payload }) {

    /*console.log('[sages] requestDetailMasterProduct : ', payload);*/

    const apiURL = `${url}/backend/v1/product/${payload.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
        });

        /*console.log("[API] GET : ", data);*/

        yield put(requestDetailMasterProductSuccess(data));

    } catch (error) {
        yield put(requestDetailMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* putMasterProduct({ payload }) {
    /*console.log('[sages] putMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/product/${payload.uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_PUT(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(putMasterProductSuccess(data));

    } catch (error) {
        yield put(putMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* deleteMultipleMasterProduct({ payload }) {
    /*console.log('[sages] deleteMultipleMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/product`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_DELETE(
            {
                url: apiURL,
                array: payload?.array
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(deleteMultipleMasterProductSuccess(data));

    } catch (error) {
        yield put(deleteMultipleMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* patchMultipleMasterProduct({ payload }) {
    /*console.log('[sages] patchMultipleMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/product`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_PATCH(
            {
                url: apiURL,
                array: payload?.array,
                data: payload?.data,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(patchMultipleMasterProductSuccess(data));

    } catch (error) {
        yield put(patchMultipleMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* putMultipleMasterProduct({ payload }) {
    /*console.log('[sages] putMultipleMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/product`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_PUT(
            {
                url: apiURL,
                array: payload?.array,
                data: payload?.data,
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(putMultipleMasterProductSuccess(data));

    } catch (error) {
        yield put(putMultipleMasterProductFail(error));
    }

    //====================================================================================================================
}

export function* checkBarcode({ payload }) {
    /*console.log('[sages] checkBarcode : ', payload);*/
    const apiURL = `${url}/backend/v1/product/check`;

    //====================================================================================================================

    try {
        const data = yield method_POST(
            {
                url: apiURL,
                data: payload.data
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(checkBarcodeSuccess(data));

    } catch (error) {
        yield put(checkBarcodeFail(error));
    }

    //====================================================================================================================
}


export function* importMasterProduct({ payload }) {
    /*console.log('[sages] importMasterProduct : ', payload);*/
    const apiURL = `${url}/backend/v1/import/product-bulk`;
    const formData = new FormData();
    formData.append('file', payload.file);
    //====================================================================================================================

    try {
        const data = yield method_IMPORT(
            {
                url: apiURL,
                data: formData,
                upload: true
            }
        );

        /*console.log("[API] POST : ", data);*/

        yield put(importMasterProductSuccess(data));

    } catch (error) {
        yield put(importMasterProductFail(error));
    }

    //====================================================================================================================

}

export function* requestImportMasterProduct({ payload }) {

    /*console.log('[sages] requestImportMasterProduct : ', payload);*/

    const apiURL = `${url}/backend/v1/import/product-bulk`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
            params: {
                "pagination[page]": payload.page === 0 ? 1 : payload.page,
                "pagination[limit]": payload.limit,
                "sort[field]": payload.field,
                "sort[order]": payload.order,
            }
        });

        /*console.log("[API] GET : ", data);*/

        yield put(requestImportMasterProductSuccess(data));

    } catch (error) {
        yield put(requestImportMasterProductFail(error));
    }

    //====================================================================================================================
}



export function* searchProduct({ payload }) {
    /*console.log('[sages] searchProduct : ', payload);*/
    // const apiURL = `${url}/backend/v1/search/product`;

    const apiURL = `${url}/backend/v2/search/product`;
    //====================================================================================================================

    try {
        const data = yield method_POST(
            {
                url: apiURL,
                data: {
                    "branch_code": payload?.branch_code,
                    "pagination": {
                        "page": payload?.page || 1,
                        "limit": payload?.limit || 10
                    },
                    "filter": {
                        "q": payload?.q
                    },
                    "sort": {
                        "field": "_score",
                        "order": "desc"
                    }
                }
            }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(searchProductSuccess(data));

    } catch (error) {
        yield put(searchProductFail(error));
    }

    //====================================================================================================================
}


export function* watchMasterProduct() {

    /*console.log('[sages] watchMasterProduct : ✅');*/

    yield all([
        takeLatest(requestMasterProductStart, requestMasterProduct),
        takeLatest(postMasterProductStart, postMasterProduct),
        takeLatest(patchMasterProductStart, patchMasterProduct),
        takeLatest(deleteMasterProductStart, deleteMasterProduct),
        takeLatest(requestDetailMasterProductStart, requestDetailMasterProduct),
        takeLatest(putMasterProductStart, putMasterProduct),
        takeLatest(deleteMultipleMasterProductStart, deleteMultipleMasterProduct),
        takeLatest(patchMultipleMasterProductStart, patchMultipleMasterProduct),
        takeLatest(putMultipleMasterProductStart, putMultipleMasterProduct),
        takeLatest(checkBarcodeStart, checkBarcode),
        takeLatest(importMasterProductStart, importMasterProduct),
        takeLatest(requestImportMasterProductStart, requestImportMasterProduct),
        takeLatest(searchProductStart, searchProduct),
    ])
}



